const dateFormat = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC'
})

/**
 * Formats an ISO date (YYYY-MM-DD or a full timestamp) the same way on the
 * server and in the browser.
 */
export const formatDate = (value: string | null | undefined): string => {
    if (!value) return ''

    const date = new Date(value.length === 10 ? `${value}T00:00:00Z` : value)

    return Number.isNaN(date.getTime()) ? '' : dateFormat.format(date)
}

export const escapeHtml = (value: string): string => value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
